/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-11 10:05:45
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-24 14:00:27
 * @name: 用户模块服务
 * @Description: 用户模块服务
 * @FilePath: \project\src\module\workflow\workflow.service.js
 * @Author: desktop
 */
import workflowController from "./workflow.controller";
const workflowService = class {
	constructor() {
		this.workflowController = new workflowController();
	}
	/**
	 * @Auther: 罗耀祖
	 * @LastEditors: 罗耀祖
	 * @description: 待打回的步骤列表
	 * @param {Object} req 传参 
	 */
	getSaleSercviceFlowProcessList(req) {
		return new Promise((resolve, reject) => {
			this.workflowController.getSaleSercviceFlowProcessList(req).then((ctx) => {
				resolve(ctx.response);
			}).catch((ctx) => {
				reject(ctx.response);
			});
		})
	}
}
export default workflowService;